<template>
  <div class="container mt-4">
    <div v-if="order">
      <b-row>
        <b-col>
          <h3>Invoice #{{ order.Number }}</h3>
        </b-col>
        <b-col class="text-right">
          <h3>{{ order.Date | moment("dddd, MMMM Do YYYY") }}</h3>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col style="white-space: pre-line;">
          <h5>Shipping Address</h5>
          {{ order.ShipToAddress }}
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-table striped hover :items="order.Lines" :fields="LineFields">
          <template #cell(ItemNumber)="data">
            <b-link
              :to="{
                name: 'ProductDetail',
                query: { number: data.item.ItemNumber }
              }"
              >{{ data.item.ItemNumber }}</b-link
            >
          </template>
        </b-table>
      </b-row>
    </div>
  </div>
</template>

<script>
import store from "@/store.js";
import OrderHistoryService from "@/services/OrderHistoryService";
import moment from "moment";

function GetOrder(key, done) {
  OrderHistoryService.GetReckonInvoice(key)
    .then(response => {
      done(null, response.data);
    })
    .catch(() => {
      done("unable to get order");
    });
}

export default {
  name: "ViewOrder",
  data() {
    return {
      order: null,
      error: null
    };
  },
  computed: {
    LineFields() {
      return [{ key: "ItemNumber" }, { key: "Quantity" }];
    }
  },
  beforeRouteEnter(to, from, next) {
    GetOrder(to.params.key, (err, order) => {
      next(vm => vm.setData(err, order));
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.order = null;
    GetOrder(to.params.key, (err, order) => {
      this.setData(err, order);
      next();
    });
  },
  methods: {
    setData(err, order) {
      if (err) {
        this.error = err.toString();
      } else {
        this.order = order;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/ViewOrder/ViewReckonOrder.vue